import { ExportTarget } from '../types';

export const EXPORT_TARGETS: ExportTarget[] = [
  // Instagram
  { label: 'Square', platform: 'Instagram', width: 1080, height: 1080 },
  { label: 'Portrait', platform: 'Instagram', width: 1080, height: 1350 },
  { label: 'Landscape', platform: 'Instagram', width: 1080, height: 566 },
  { label: 'Stories', platform: 'Instagram', width: 1080, height: 1920 },
  // X (Twitter)
  { label: 'Landscape', platform: 'X', width: 1200, height: 675 },
  { label: 'Square', platform: 'X', width: 1080, height: 1080 },
  // LinkedIn
  { label: 'Landscape', platform: 'LinkedIn', width: 1200, height: 627 },
  { label: 'Square', platform: 'LinkedIn', width: 1080, height: 1080 },
  // Facebook
  { label: 'Landscape', platform: 'Facebook', width: 1200, height: 630 },
  { label: 'Square', platform: 'Facebook', width: 1080, height: 1080 },
  { label: 'Stories', platform: 'Facebook', width: 1080, height: 1920 },
];

export const PLATFORMS = ['Instagram', 'X', 'LinkedIn', 'Facebook'] as const;
export type Platform = (typeof PLATFORMS)[number];
